export const substatuses = [
  '',
  'AS_STATE',
  'CREDIT_FREEZE',
  'WELCOME_BACK_SCREEN',
  'FULLY_APPROVED',
  'PRE-APPROVED',
  'PENDING_VO_IDENTITY',
  'PARTIALLY_APPROVED',
  'PRE-APPROVED_MULTI',
  'PENDING_MULTI',
  'PRE_BUREAU_FAILED',
  'DECLINED_WITH_COBO_OFFER',
  'DECLINED_MULTI',
  'NO_COBORROWER_OFFERED',
  'EXCEPTION',
]


export const formControlsId = [
  // 'amount_i',
  'firstName_i',
  'secondName_i',
  'addressInput',
  'cityInput',
  'stateOptionSmall',
  'stateOptionLarge',
  'zipCodeInput',
  'ssnInputId',
  'dobInputId',
  'mobileInputId',
  'incomeInputId'
]

export const formControlsInputId = [
  // 'amount_i',
  'firstName_i',
  'secondName_i',
  'addressInput',
  'cityInput',
  'zipCodeInput',
  'ssnInputId',
  'dobInputId',
  'mobileInputId',
  'incomeInputId'
]
